import { useCallback } from "react";
import { Button, Grid } from "antd";
import {useDispatch, useSelector} from "react-redux";
import { Input, SwitchButton } from "components/base";
import { searchIcon, plusIcon } from "svgs";
import { setModalName, setServiceCentresSearch } from "store/actions";

import "styles/components/tab-headers/service-center-header.scss";
import {AppState} from "../../store";

const { useBreakpoint } = Grid;

export default function ServiceCentresHeader() {
  const dispatch = useDispatch();
  const screens = useBreakpoint();
    const {
        common: { userType = 1 },
    } = useSelector<AppState, AppState>((state) => state);

  // Determine screen size
  const isMobile = !screens.sm;
  const isTablet = screens.sm && !screens.lg;

  const onAdd = useCallback(() => {
    dispatch(setModalName("add_service_centre"));
  }, [dispatch]);

    const onSearch = useCallback(
      (event: React.ChangeEvent<HTMLInputElement>) => {
        dispatch(setServiceCentresSearch(event.target.value));
      },
      [dispatch]
    );

  // Get button text based on screen size
   const getButtonText = () => {
    if (isMobile) return null; // Icon only on mobile
    if (isTablet) {
      return (
        <span style={{ fontSize: '16px', fontWeight: 500 }}>
          Add
        </span>
      );
    }
    return (
      <span style={{ fontSize: '16px', fontWeight: 300 }}>
        Add Service Center
      </span>
    );
  };

  return (
    <div className="service-centres-header">
      <div className="header-content">
        {/* Search Input */}
        <div className="search-wrapper">
               <Input
                 customClasses="--standard"
                 placeholder="Search Service Centers..."
                 prefix={searchIcon}
                 onChange={onSearch}
               />
             </div>

        {/* Actions */}
          {userType <= 3 && <>
              <div className="actions-container">
                  <Button
                      type="primary"
                      icon={<span className="btn-icon">{plusIcon}</span>}
                      onClick={onAdd}
                      className="add-btn"
                  >
                      {getButtonText()}
                  </Button>
              </div>
          </>}

      
      </div>
      {isMobile && ( <h1 style={{ paddingTop: "16px", alignItems: "left" }}>Service Centers</h1>)}
    </div>
  );
}